import {
  IGetAllProjectsResponseModel,
  IGetProjectRequestModel,
  IGetProjectResponseModel,
  IUpdateProjectRequestModel,
} from "@lib/types";
import Clients from "core/api-clients";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const PROJECTS_QUERY_KEY = {
  GET: "project",
  GET_ALL: "projects",
};

export function useProjects(account_number: number) {
  return useQuery<Array<IGetAllProjectsResponseModel>>({
    queryKey: [PROJECTS_QUERY_KEY.GET_ALL],
    queryFn: () => Clients.ManagementBackend.Projects.getAll(account_number),
  });
}

export function useUpdateProject(accountNumber: number, projectId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (requestModel: IUpdateProjectRequestModel) =>
      await Clients.ManagementBackend.Projects.put(
        accountNumber,
        projectId,
        requestModel,
      ),
    onSuccess: () => {
      // when we add getting a single project, invalidate that as well
      queryClient.invalidateQueries({ queryKey: [PROJECTS_QUERY_KEY.GET_ALL] });
    },
  });
}

export function useProject(
  account: number,
  project: number,
  requestModel: IGetProjectRequestModel,
) {
  return useQuery<IGetProjectResponseModel>({
    queryKey: ["project", account, project],
    queryFn: () =>
      Clients.ManagementBackend.Projects.get(account, project, requestModel),
  });
}
